export const assistantStatusStyle = {
    manual: "bg-green-100 text-green-800",
    approved: "bg-green-100 text-green-800",
    pending: "bg-yellow-100 text-yellow-800",
    waiting: "bg-gray-100 text-gray-600",
    error: "bg-pink-100 text-red-600",
  };